import React, { useEffect, useState } from 'react';
import { Timeline, Typography, Spin, Flex, Avatar, Tooltip } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { getTaskActivities } from '../../redux/actions/tasks';
import UserAvatar from '../UserAvatar';

dayjs.extend(relativeTime);

const { Text } = Typography;

const TaskActivities = ({ taskId, activeTab }) => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchActivities = async () => {
    setLoading(true);
    const res = await getTaskActivities({ taskId });
    if (res.ack) {
      setActivities(res.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (taskId && activeTab === '2') {
      fetchActivities();
    }
  }, [taskId, activeTab]);

  const getActivityIcon = (type) => {
    switch (type) {
      case 'created':
        return '🆕';
      case 'status_changed':
        return '🔄';
      case 'commented':
        return '💬';
      case 'assigned':
        return '👤';
      case 'deleted':
        return '🗑️';
      default:
        return '📝';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'created':
      case 'task_completed':
        return '#52c41a'; // Green
      case 'deleted':
      case 'task_archived':
        return '#ff4d4f'; // Red
      case 'commented':
        return '#eb2f96'; // Pink/Purple
      case 'assignee_updated':
      case 'labels_updated':
        return '#1677ff'; // Blue
      default:
        return '#bfbfbf'; // Gray
    }
  };

  return (
    <div style={{ padding: '24px 16px', maxHeight: '600px', overflowY: 'auto', minHeight: '200px' }}>
      {loading ? (
        <Flex justify="center" align="center" style={{ padding: '60px 0' }}>
          <Spin />
        </Flex>
      ) : activities.length === 0 ? (
        <Flex justify="center" align="center" style={{ padding: '60px 0' }}>
          <Text type="secondary">No activity logged yet.</Text>
        </Flex>
      ) : (
        <Timeline
          items={activities.map((activity) => ({
          dot: (
            <div 
              style={{ 
                width: 12, 
                height: 12, 
                borderRadius: '50%', 
                border: `2px solid ${getActivityColor(activity.activity_type)}`,
                background: '#fff',
                marginTop: '12px'
              }} 
            />
          ),
          children: (
            <div style={{ marginBottom: '28px', paddingLeft: '4px' }}>
              <Flex gap={12} align="start">
                <UserAvatar size={32} user={activity.user} />
                <div style={{ flex: 1, marginTop: '-2px' }}>
                  <Flex align="center" gap={8} wrap="wrap" style={{ marginBottom: '4px' }}>
                    <Text strong style={{ fontSize: '14px', color: '#1a1a1a' }}>
                      {activity.user?.first_name} {activity.user?.last_name ?? ''}
                    </Text>
                    <Text type="secondary" style={{ fontSize: '12px' }}>
                      • {dayjs(activity.createdAt).fromNow()}
                    </Text>
                  </Flex>
                  <Text type="secondary" style={{ fontSize: '14px', display: 'block' }}>
                    {activity.description}
                  </Text>
                  
                  {activity.details && (
                    <div style={{ 
                      marginTop: '10px', 
                      padding: '10px 14px', 
                      background: '#f9f9f9', 
                      borderRadius: '8px',
                      border: '1px solid #f0f0f0',
                      boxShadow: '0 1px 2px rgba(0,0,0,0.02)'
                    }}>
                      <Text type="secondary" style={{ fontSize: '13px', lineHeight: '1.5' }}>
                        {activity.details}
                      </Text>
                    </div>
                  )}
                </div>
              </Flex>
            </div>
          ),
        }))}
        />
      )}
    </div>
  );
};

export default TaskActivities;
